export default "__VITE_ASSET__DTY8cLu2__"